import React from 'react';
import { Router } from '@reach/router';

import CheckoutPage from 'dpages/checkout';
import ErrorPage from './404';

const Training = () => (
  <Router>
    <CheckoutPage path="/checkout/:trainingId" />
    <ErrorPage path="/checkout/" />
  </Router>
);

export default Training;
